/**
 * Single source of truth for the accepted import file extensions. Consumed by
 * `pharos-back-deliveries` (multipart extension validation) and `pharos-ui-frontoffice`
 * (dropzone client-side validation, which derives its dotted `accept` attribute from these).
 * Values are BARE (no leading dot) to match the backend's parsed-extension comparison.
 */
export const IMPORT_SUPPORTED_EXTENSIONS = ['csv', 'xlsx'] as const;
export type ImportSupportedExtension = (typeof IMPORT_SUPPORTED_EXTENSIONS)[number];

/**
 * Single source of truth for the maximum import file size, in bytes. Consumed by
 * `pharos-back-deliveries` (multipart `fileSize` limit) and `pharos-ui-frontoffice`
 * (dropzone client-side validation).
 */
export const MAX_IMPORT_FILE_SIZE_BYTES = 5 * 1024 * 1024;

/** Single source of truth for the column name appended to a generated import error report. */
export const IMPORT_ERROR_REPORT_COLUMN = 'Error type';

/**
 * DISPLAY-only cap on `ImportDetail.errors.lines`, distinct from the larger PERSISTENCE cap
 * `MAX_STORED_LINE_ERRORS`.
 */
export const MAX_REPORTED_LINE_ERRORS = 50;

/** File-level (`ImportError.code`) codes pushed onto `errors.global`, pushed when the persistence cap is exceeded. */
export const IMPORT_GLOBAL_ERROR_CODE = {
  TOO_MANY_LINE_ERRORS: 'TooManyLineErrors',
} as const;
export type ImportGlobalErrorCode = (typeof IMPORT_GLOBAL_ERROR_CODE)[keyof typeof IMPORT_GLOBAL_ERROR_CODE];
